import { GetRewardsStatusResponse, WalletTxMethod } from "kz-ui-sdk";

export interface RewardTileVisibility {
  dailyFree: boolean;
  freeBalls: boolean;
  cashback: boolean;
}

const CASHBACK_METHODS = [
  WalletTxMethod.DailyCashBack,
  WalletTxMethod.InstantCashBack,
  WalletTxMethod.WeeklyCashBack,
  WalletTxMethod.MonthlyCashBack,
] as const;

/**
 * A tile shows when the Promotion page shows that card (locked included):
 * `useDailyFreeSlot.shouldRender`, `!shouldHideReferralReward`, `isCashbackAvailable`.
 */
export function getRewardTileVisibility(
  rewards: GetRewardsStatusResponse | undefined,
  isReferralRewardEnabled: boolean | undefined,
  isBlacklisted: boolean,
): RewardTileVisibility {
  const isDailyShown = (status?: { enabled?: boolean; eligible?: boolean }) =>
    !!status?.enabled && !(isBlacklisted && !status.eligible);

  return {
    dailyFree:
      isDailyShown(rewards?.[WalletTxMethod.DailyBonus]) || isDailyShown(rewards?.[WalletTxMethod.DailyStreak]),
    freeBalls: !!isReferralRewardEnabled,
    cashback: CASHBACK_METHODS.some((method) => !!rewards?.[method]),
  };
}
